module.exports = __webpack_public_path__ + "static/jeremie2-33a93b8d27597beb48e02e723fcec4ba.jpeg";